<template>
  <div
    :class="['app', { '-warn-explorer' : warnIE && isDesktop }]"
    v-if="!isLoading"
  >
    <transition name="slide-fade">
      <ie-warning
        v-if="warnIE && isDesktop"
        @close="warnIE = false"
      />
    </transition>

    <router-view :warn-explorer="warnIE" />

    <c-feedback
      :type="feedback.type"
      :title="feedback.title"
      :text="feedback.text"
      :icon="feedback.icon"
      @close="closeFeedback"
    />
  </div>
  <div
    class="loading-screen"
    v-else
  >
    <c-spinner
      v-if="isLoading"
    />
    <div v-if="isLoading && showLoadingMessage">
      <h1>Aguarde</h1>
      <h4>Estamos preparando o seu clube</h4>
    </div>
  </div>
</template>

<script>
import decode from 'jwt-decode'
import * as types from '@store/types'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    IeWarning: () => import('@components/Layout/IeWarning')
  },

  data () {
    return {
      isLoading: false,
      showLoadingMessage: false,
      warnIE: false
    }
  },

  computed: {
    ...mapGetters({
      feedback: types.FEEDBACK,
      auth: types.AUTH,
      config: types.CONFIG_MAIN,
      generic_login: types.FLAG_GENERIC_APP
    })
  },

  async created () {
    const url = (window.location.href)
    const token = url.match(/(?:token=)(.*)(?=&company)/)
    const needActivate = url.includes('activate=true')

    if (needActivate) {
      await this.handleActivation(token)
      return
    }

    if (token !== null) {
      await this.handleToken(token)
    }

    const { token: hasToken, expiresAt } = this.auth
    const isLogged = (Date.now() < expiresAt) && hasToken

    this.isLoading = true
    this.showLoadingMessage = isLogged
    await this.getConfig(isLogged)

    if (this.config.custom_script) { this.insertExternalScript() }

    if (!isLogged &&
      this.config.has_api_access &&
      !this.config.has_restrict_access &&
      !!this.config.logout_url &&
      !this.generic_login
    ) {
      window.location.replace(this.config.logout_url)
      return
    }

    if (!isLogged && !!this.config.logout_url && !this.generic_login) {
      window.location.replace(this.config.logout_url)
      return
    }

    const hasLogout = (window.location.search).includes('logout=true')
    let getStorage = null
    if (localStorage !== null) getStorage = localStorage.getItem('url')

    if (!isLogged && this.config.generic_app && getStorage && !hasLogout) {
      await (window.location.href = (getStorage))
    }

    if (hasLogout) {
      window.localStorage.removeItem('url')
    }

    this.isLoading = false
    this.showLoadingMessage = false

    if (isLogged && this.$route.name !== 'Recompensas') {
      window.dataLayer.push({
        event: 'home'
      })

      window.dataLayer.push({
        slug_account: this.auth.company_name
      })
    }
  },

  mounted () {
    this.checkIE()
  },

  methods: {
    ...mapMutations({
      setGenericFlag: types.FLAG_GENERIC_APP,
      auth_credentials: types.AUTH_CREDENTIALS
    }),

    ...mapActions({
      closeFeedback: types.FEEDBACK_CLOSE,
      getConfig: types.CONFIG_FETCH,
      getUser: types.USER
    }),

    checkIE () {
      const ua = navigator.userAgent
      this.warnIE = ua.includes('MSIE ') || ua.includes('Trident/') || ua.includes('Edge')
    },

    insertExternalScript () {
      // eslint-disable-next-line
      let element = document.createElement('link')
      element.setAttribute('rel', 'stylesheet')
      element.setAttribute('type', 'text/css')
      element.setAttribute('href', this.config.custom_script)
      document.head.appendChild(element)
    },

    async handleActivation (token) {
      const user = await this.getUser(decode(token[0]).document)
      this.auth_credentials({
        document: decode(token[0]).document,
        ...user,
        activate: true,
        api: true
      })
      location.href = '/formulario-de-ativacao'
    },

    async handleToken (token) {
      const { generic_app: generic_flag } = decode(token[0])
      await this.setGenericFlag(!!generic_flag)
    }
  }
}
</script>

<style lang="scss">
  @import '~@style/reference';
  .loading-screen {
    display: flex;
    text-align: center;
    margin: 0 auto;
    flex-direction: column;
    height: 100vh;
    justify-content: center;
    h1 {
      font-size: 22px;
      line-height: 26px;
      padding: 12px;
      color: #202950;
    }
    h4 {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #5E6684;
    }
  }
  .app.-warn-explorer {
    min-height: 100%;
    margin-top: 80px;
  }
</style>

<style lang="scss" src="@style/style.scss">



// WEBPACK FOOTER //
// src/App.vue